import React from 'react';

import './index.scss';

import BlackInstagramIcon from 'images/icons/svg/icon-instagram-black.svg';
import BlackSnapchatIcon from 'images/icons/svg/icon-snapchat-black.svg';
import BlackYoutubeIcon from 'images/icons/svg/icon-youtube-black.svg';
import BlackImageIcon from 'images/icons/svg/icon-image-black.svg';
import BlackVideoIcon from 'images/icons/svg/icon-video-black.svg';
import TikTokIcon from 'images/icons/svg/icon-tictok.svg';

import {ContentSnType} from './constants';

const ContentType = ({value, id}) => {

    const iconShown = (value) => {
        if (value === ContentSnType[1] || value === ContentSnType[2] || value === ContentSnType[3]) {
            return <img className="campaign-platform-icon" src={BlackInstagramIcon} />
        } else if (value === ContentSnType[4]) {
            return <img className="campaign-platform-icon" src={TikTokIcon} />
        } else if (value === ContentSnType[6]) {
            return <img className="campaign-platform-icon" src={BlackSnapchatIcon} />
        } else if (value === ContentSnType[7]) {
            return <img className="campaign-platform-icon" src={BlackYoutubeIcon} />
        } else if (value === ContentSnType[8]) {
            return <img className="campaign-platform-icon" src={BlackVideoIcon} />
        } else if (value === ContentSnType[9] || value === ContentSnType[5]) {
            return <img className="campaign-platform-icon" src={BlackImageIcon} />
        } else {
            return <div></div>
        }
    }

    return (
        <div className="content-type">
            <div className="content-type__icon">{iconShown(value)}</div>
            <div className="content-type__name" data-content-sn-type-id={id}>
                {value}
            </div>
        </div>
    );
};

export default ContentType;



// WEBPACK FOOTER //
// ./components/content_type/index.js